import React, { useState, useRef, useContext } from 'react';
import { FaRegSquare, FaSquareCheck, FaRegCircle, FaRegCircleDot } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

import api from '../../services/api';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext from '../../contexts/language';
import AuthContext from '../../contexts/auth';

export default function InscricaoImprensa() {

    const { signed } = useContext(AuthContext);
    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [error_message, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [success_message, setSuccessMessage] = useState('');

    const all_events = [
        {
            id: 1,
            title: "10:00 - 10:50 - Painel: O Papel do Estado na Transição para uma Economia Justa e de Baixo Carbono",
            title_en: "10:00am - 10:50am - Panel: The Role of the State in the Transition to a Just and Low-Carbon Economy",
        },
        {
            id: 2,
            title: "11:00 - 11:50 - Painel: Mobilização de Capital Privado para a Transição do Clima e da Natureza",
            title_en: "11:00am - 11:50am - Panel: Mobilizing Private Capital for Climate and Nature Transition",
        },
        {
            id: 3,
            title: "13:30 - 14:20 - Painel: Fomento à Sociobioeconomia da Amazônia: integrando a diversidade para ampliar o impacto de mulheres indígenas",
            title_en: "01:30pm - 02:20pm - Panel: Fostering Amazon Socio-Bioeconomy: embracing diversity to amplify impact for indigenous women",
        },
        {
            id: 4,
            title: "14:25 - 15:15 - Painel: Destravando Investimentos Privados para a Bioeconomia, Restauração e Agricultura Regenerativa: o Caminho até a COP30",
            title_en: "02:25pm - 03:15pm - Panel: Unlocking private investments to bioeconomy, restoration and regenerative agriculture: The road to COP 30",
        },
        {
            id: 5,
            title: "15:20 - 16:10 - Painel: Como navegar e ampliar os Investimentos globais e os fluxos comerciais para cadeias de valor produtivas de baixo carbono?",
            title_en: "03:20pm - 04:10pm - Panel: Navigating and amplifying global investments and trade flows to low-carbon productive value chains",
        },
        {
            id: 6,
            title: "16:15 - 17:05 - Painel: Produtividade e Sustentabilidade: um Novo Paradigma para a Economia",
            title_en: "04:15pm - 05:05pm - Panel: Productivity and Sustainability: A New Paradigm for the Economy",
        },
        {
            id: 7,
            title: "17:10 - 18:00 - Painel: Finanças Inovadoras para Florestas e Biomas Tropicais",
            title_en: "05:10pm - 06:00pm - Panel: Innovative Finance for Tropical Forests and Biomes",
        },
        {
            id: 8,
            title: "18:05 - 18:55 - Painel: Aumentando a escala de Soluções Baseadas na Natureza (SbN) para a ação climática: como destravar o potencial da restauração de florestas tropicais",
            title_en: "06:05pm - 06:55pm - Panel: Scaling Up NbS for Climate Action: how to unlock the potential of tropical forest restoration",
        },
    ];

    const [selectedEvents, setSelectedEvents] = useState([]);
    const handleEventPress = (id) => {
        setSelectedEvents(prev =>
          prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    }
    
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [medium, setMedium] = useState('');
    const [phone, setPhone] = useState('');
    const [type, setType] = useState('online');
    const [intend, setIntend] = useState('');
    
    const nameInput = useRef(null);
    const emailInput = useRef(null);
    const mediumInput = useRef(null);
    const intendInput = useRef(null);

    function clearMessage(){
        setError(false);
        setErrorMessage('');
        setSuccess(false);
        setSuccessMessage('');
    }

    function clearState(){
        setName('');
        setEmail('');
        setMedium('');
        setPhone('');
        setType('online');
        setIntend('');
        setSelectedEvents([]);
    }

    function changeType(type){
        setType(type);
        if(type=="online"){
            setIntend('');
            setSelectedEvents([]);
        }
    }

    function changeIntend(intend){
        setIntend(intend);
        if(intend === 'Somente dia 26/05' || intend === ''){
            setSelectedEvents([]);
        }
    }

    async function sendRegister(e){
        e.preventDefault();
        setLoading(true);
        setSuccess(false);
        setSuccessMessage("");

        if(name.trim() === ''){
            nameInput.current.focus();
            setLoading(false);
            setError(true);
            setErrorMessage(language.error_input);
            return;
        }else if(email.trim() === ''){
            emailInput.current.focus();
            setLoading(false);
            setError(true);
            setErrorMessage(language.error_input);
            return;
        }else if(medium.trim() === ''){
            mediumInput.current.focus();
            setLoading(false);
            setError(true);
            setErrorMessage(language.error_input);
            return;
        }else if(type === ''){
            setLoading(false);
            setError(true);
            setErrorMessage(language.error_type);
            return;
        }

        /* if(type==='presencial'){
            const is_checked = eventChecked(events);
            if(!is_checked){
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_select);
                return;
            }
        } */

        /* if(type==='presencial'){
            if(intend.trim() === ''){
                intendInput.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }
        } */

        try{
            const response = await api.post(`/register`, {
                lang,
                name,
                email,
                medium,
                phone,
                type_subscribe: type,
                type_user: 'press',
                intend,
                events: selectedEvents
            });

            if(response.data.status==="success"){
                setLoading(false);
                setError(false);
                setErrorMessage('');
                setSuccess(true);
                setSuccessMessage(language.success);
                clearState();
            }else if(response.data.status==="email_error"){
                setLoading(false);
                setError(true);
                setErrorMessage(language.email_error);
                setSuccess(false);
                setSuccessMessage('');
            }else{
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_email);
                setSuccess(false);
                setSuccessMessage('');
            }
            
        }catch(err){
            setLoading(false);
            setError(true);
            setErrorMessage(err.message);
            setSuccess(false);
            setSuccessMessage("");
        }
    }

    return (
        <div className="page">
            <Header />
            <div className="content">
                <div className="full mt-30 mb-40 text-center">
                    <form onSubmit={sendRegister} className={`form ${ loading ? 'loading' : '' }`}>
                        <h3 className="title_b color_4 mt-30 mb-30">
                            {language.menu_sub_inscricao_imprensa}
                        </h3>
                        <div className="container m-0">
                            {lang==='pt' ? 
                            <div className="col-md-6 m-auto text-2">
                                <p>Preencha sua inscrição para o <strong>The 10th Frances Tustin International Conference</strong> que ocorrerá em São Paulo, de 29 de Julho à 01 de Agosto de 2026.</p>
                               {/*  <p className="text-alert">INSCRIÇÃO PRESENCIAL - ENCERRADA</p> */}
                            </div>:
                            <div className="col-md-6 m-auto text-2">
                                <p>Fill out your registration form for the <strong>The 10th Frances Tustin International Conference</strong>, which will take place in São Paulo, from July 29 to August 1, 2026.</p>
                                {/* <p className="text-alert">IN-PERSON REGISTRATION - CLOSED</p> */}
                            </div>}
                        </div>
                        {/* <div className="d-input mt-20">
                            <label>{language.type}: <span>*</span></label>
                            <div className="d-check">
                                <div className={`d-check-label ${type==='presencial' ? 'checked' : ''}`} onClick={() => {changeType('presencial');clearMessage();}}>
                                    {type==='presencial' ?
                                    <FaRegCircleDot />:
                                    <FaRegCircle />}
                                    <span>{language.presencial}</span>
                                </div>
                                <div className={`d-check-label ${type==='online' ? 'checked' : ''}`} onClick={() => {changeType('online');clearMessage();}}>
                                    {type==='online' ?
                                    <FaRegCircleDot />:
                                    <FaRegCircle />}
                                    <span>{language.online}</span>
                                </div>
                            </div>
                        </div> */}
                        <div className="d-input">
                            <label>{language.name}: <span>*</span></label>
                            <input type="text" ref={nameInput} value={name} onChange={e => {setName(e.target.value);clearMessage();}} />
                        </div>
                        <div className="d-input">
                            <label>{language.email}: <span>*</span></label>
                            <input type="email" ref={emailInput} value={email} onChange={e => {setEmail(e.target.value);clearMessage();}} />
                        </div>
                        <div className="d-input">
                            <label>{language.medium}: <span>*</span></label>
                            <input type="text" ref={mediumInput} value={medium} onChange={e => {setMedium(e.target.value);clearMessage();}} />
                        </div>
                        <div className="d-input">
                            <label>{language.phone}:</label>
                            <input type="text" value={phone} onChange={e => {setPhone(e.target.value);clearMessage();}} />
                        </div>

                        {type==='presencial' &&
                        <>
                            <div className="d-select">
                                <label>{language.intend}: <span>*</span></label>
                                <select ref={intendInput} value={intend} onChange={e => {changeIntend(e.target.value);clearMessage();}}>
                                    <option value="">{lang==='pt' ? 'Selecione uma opção' : 'Select an option'}</option>
                                    <option value="Somente dia 26/05">{lang==='pt' ? 'Somente dia 26/05' : 'Only on 26/05'}</option>
                                    <option value="Somente dia 27/05">{lang==='pt' ? 'Somente dia 27/05' : 'Only on 27/05'}</option>
                                    <option value="Em ambos os dias">{lang==='pt' ? 'Em ambos os dias' : 'Both days'}</option>
                                </select>
                            </div>

                            <div className={`container m-0 mt-4 ${(intend === 'Somente dia 27/05' || intend === 'Em ambos os dias') ? '' : 'd-none'}`}>
                                <div className="col-md-6 m-auto text-2">
                                    <p><strong>{lang==='pt' ?
                                    <>Em relação aos painéis que teremos no dia <span className="color_4">27/05</span>, selecione abaixo quais você tem a intenção de participar</>:
                                    <>Regarding the panels scheduled for <span className="color_4">May 27th</span>, select below the ones you wish to attend</>}:</strong></p>
                                    <div className="box-all-events">
                                        {all_events.map(item => (
                                        <div
                                            key={`events-${item.id}`}
                                            className={`event-subscribe ${selectedEvents.includes(item.id) ? 'checked' : ''}`}
                                            onClick={() => handleEventPress(item.id)}
                                        >
                                            <div className={`event-check ${lang}`}>
                                                {selectedEvents.includes(item.id) ? <FaSquareCheck /> : <FaRegSquare />}
                                            </div>
                                            <div className="event-name">
                                                {lang === 'pt' ? item.title : item.title_en}
                                            </div>
                                        </div>))}
                                    </div>
                                </div>
                            </div>
                            
                        </>}

                        {success && <div className="success space mt-20 mb-20">{success_message}</div>}
                        {error && <div className="error space mt-20 mb-20">{error_message}</div>}

                        <div className="d-btn mt-30">
                            <button type="submit" className="btn-send bg_color_4">{language.send} {language.inscricao}</button>
                        </div>
                    </form>

                </div>
            </div>
            <Footer />
        </div>
    );
}
